module.exports = __webpack_public_path__ + "img/contact-right.f53bef4c.svg";